<script>
	import { onMount } from "svelte";
	import { push } from "svelte-spa-router";
	import Icon from "svelte-awesome";
	import { faHome } from "@fortawesome/free-solid-svg-icons";
	import DifficultyEnums from "../../enums/Difficulty";
	import GameNameEnums from "../../enums/GameName";
	// constantes
	const GAME_NAME = "f1-start-timer";
	// variables
	let difficultySelected = "normal";
	
	onMount(() => {
		if (sessionStorage.getItem("difficulty-f1-start-timer")) {
			difficultySelected = sessionStorage.getItem("difficulty-f1-start-timer");
		}
	});
    
	function handleInputRadio(difficulty) {
		sessionStorage.setItem("difficulty-f1-start-timer", difficulty);
		difficultySelected = difficulty;
	}
	
	function handleStart() {
		push("/" + GAME_NAME + "/" + difficultySelected);
	}

	function handleRanking() {
		push("/ranking/" + GAME_NAME + "/" + difficultySelected);
	}
</script>

<style>
	.button-difficulty {
		@apply flex justify-center items-center w-2/5;
	}
	.button-difficulty input[type="radio"]:checked + label > span {
		@apply text-f1StartTimer;
	}
</style>

<div class="container-global">
	<div class="container-header">
		<div class="header-name-menu-top">
			<div class="header-button-home-menu-top">
				<span class="cursor-pointer" on:click={() => push('/')}>
					<Icon data={faHome} scale="1.4" />
				</span>
			</div>
			<div class="top-header pb-6">
				<div class="top-header text-3xl">{GameNameEnums.label(GAME_NAME)}</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="pb-8">
			<div class="flex justify-around w-3/5 m-auto">
				<div class="button-difficulty">
					<input
						id="difficulty-normal"
						class="difficulty hidden button-left"
						name="difficulty"
						type="radio"
						value="normal"
						on:click={() => handleInputRadio("normal")}
						checked={difficultySelected == "normal" ? true : false}
					/>
					<label class="w-auto flex justify-center items-center p-0 cursor-pointer" for="difficulty-normal">
						<span class="text-xl font-bold text-beige-dark">{DifficultyEnums.label("normal")}</span>
					</label>
				</div>
			</div>
		</div>
		<div class="text-center px-4 py-0">
			<button class="button-f1-start-timer" on:click={handleRanking}>Classement</button>
			<button class="button-f1-start-timer-bg" on:click={handleStart}>Start</button>
		</div>
	</div>
</div>